export default __webpack_public_path__ + "static/media/icon_project_uncontracted.2fff6b32.svg";